import { render } from "./AdminEvaluation.vue?vue&type=template&id=ba5e469c&scoped=true"
import script from "./AdminEvaluation.vue?vue&type=script&lang=js"
export * from "./AdminEvaluation.vue?vue&type=script&lang=js"

import "./review-evaluate.scss?vue&type=style&index=0&id=ba5e469c&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5e469c"]])

export default __exports__